'use strict';

const tabs = {
    selectors: {
        tabsPanel: '.js-tabs-panel',
        tabsButton: '.js-tabs-nav-button',
        tabsContent: '.js-tabs__content'
    },

    init() {
        this.bindTabClickEvents(); // Handle tab activation
    },

    // Activate the first tab on load When a tab button is clicked
    bindTabClickEvents() {
        $(document).on('click', this.selectors.tabsButton, this.handleTabButtonClick.bind(this));
        const firstTab = $(this.selectors.tabsButton).first();
        this.activateTab(firstTab);
    },

    // Handle tab switching
    handleTabButtonClick(event) {
        const $target = $(event.currentTarget);
        this.activateTab($target);
    },

    activateTab($target) {
        const $parentTabs = $target.closest('.js-tabs');
        const $targetPanel = $parentTabs.find(`[data-tab-panel="${$target.data('tab-target')}"]`);

        // Deactivate all tabs and update aria-selected
        $parentTabs.find(this.selectors.tabsButton).removeClass('tabs__button--active');
        $target.addClass('tabs__button--active');

        // Show the selected tab and hide others
        $parentTabs.find(this.selectors.tabsPanel).removeClass('tabs__panel--active').addClass('tabs__panel--hide');
        $targetPanel.removeClass('tabs__panel--hide').addClass('tabs__panel--active');
    }
};

tabs.init(); // Initialize the tabs